export default __webpack_public_path__ + "static/media/webpainting.919f9672.png";